import { Component, ElementRef, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { Subscription } from 'rxjs';

import { AuthenticationService } from '../../auth/authentication.service';
import { UserHelperService } from '../../shared/services/data-helper/user-helper.service';
import { logoutRequest } from '../../auth/auth-mode';

@Component({
    selector: 'app-user-dropdown',
    templateUrl: './user-dropdown.component.html',
    styleUrls: ['./user-dropdown.component.scss'],
    standalone: false
})
export class UserDropdownComponent implements OnDestroy {
  @Input() anchor: HTMLElement | ElementRef<any>;
  @Input() showName: boolean;
  userInfo: any;
  /** From the current-user API (shell's getCurrentUserInfo); the token name is the fallback. */
  fullName = '';
  roleName = '';
  show = false;
  public data: Array<any> = [
    { text: 'Profile', actionName: 'profile' },
    { text: 'Logout', actionName: 'logout' }
  ];
  userInfoSubscription: Subscription;
  private userDataSubscription: Subscription;

  constructor(
    private authService: AuthenticationService,
    private msalService: MsalService,
    private router: Router,
    userHelper: UserHelperService
  ) {
    this.userInfoSubscription = this.authService.userInfo$.subscribe((res) => {
      this.userInfo = res;
    });
    this.userDataSubscription = userHelper.userData$.subscribe((user) => {
      this.fullName = user?.fullName ?? '';
      this.roleName = user?.roleName ?? '';
    });
  }

  get displayName(): string {
    return this.fullName || this.userInfo?.name || '';
  }

  /** Up to two initials for the avatar — Zeymo keeps no user photos. */
  get initials(): string {
    // Words that start with a letter only — "Zeymo Admin (Sahtein)" is ZA, not Z(.
    const parts = this.displayName.trim().split(/\s+/).filter(p => /^\p{L}/u.test(p));
    return ((parts[0]?.[0] ?? '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
  }

  onDropdownButtonItemClick(ev: any) {
    switch (ev.text) {
      case 'Profile':
        this.router.navigate(['/profile']);
        break;
      case 'Logout':
        this.logout();
        break;
    }
  }

  logout() {
    this.msalService.logout(logoutRequest(this.msalService.instance));
  }

  ngOnDestroy(): void {
    this.userInfoSubscription?.unsubscribe();
    this.userDataSubscription?.unsubscribe();
  }
}
